export const BOTTOM_MENU_HEIGHT = 60;
export const BOTTOM_MENU_VISIBILITY_ANIMATION_DURATION_IN_MS = 300;
